import { useCMS } from '../context/CMSContext';
import type { SiteConfig } from '../types/cms';

/**
 * Returns the fully merged CMS config.
 * This is a convenience wrapper so existing components can migrate
 * from `import { siteConfig } from '../data/siteConfig'`
 * to `const siteConfig = useSiteConfig()` with minimal changes.
 */
export function useSiteConfig(): SiteConfig {
  const { config } = useCMS();
  return config;
}
